var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['dg-toggle', { disabled: _vm.disabled }],on:{"click":_vm.onChange}},[_c('span',{staticClass:"dg-yes"},[_vm._v("Yes")]),_c('span',{staticClass:"dg-no",class:{ muted: _vm.isChecked === true }},[_vm._v("No")]),_c('div',{staticClass:"dg-slider",class:{ active: _vm.isChecked === true }})])
}
var staticRenderFns = []

export { render, staticRenderFns }